<script setup>
import { useModal } from "../hooks/useModal";
import Modal from "./Modal.vue";
import Ytplayer from "./Ytplayer.vue";

const props = defineProps({
    id: {
        type: String,
        required: true,
    },
    classNames: {
        type: Array,
        default: () => [],
    },
});

const { isModalOpen, openModal, closeModal } = useModal();
</script>

<template>
    <button @click="openModal" class="c-thumb-movie" :class="classNames">
        <img :src="'https://img.youtube.com/vi/' + id + '/maxresdefault.jpg'" alt="" width="680" height="382" />
    </button>
    <Modal :isOpen="isModalOpen" @close="closeModal">
        <Ytplayer :isModalOpen="isModalOpen" :videoId="id"></Ytplayer>
    </Modal>
</template>
